import React from 'react'
import styled from '@emotion/styled'
import { string, node } from 'prop-types'

// Styled Components via Emotion
const HeroWrapper = styled.div`
	color: #ffffff;
	height: auto;
	left: 0;
	margin: 0 auto;
	position: absolute;
	right: 0;
	top: ${({ top }) => top || '30%'};
	width: 90%;
	${({ align }) => (align === 'center' ? 'text-align: center;' : '')}

	${({ theme }) => theme.MQ.S} {
		${({ align }) => (align === 'center' ? 'text-align: center;' : 'margin: 0; padding-left: 50px; ')}
	}

	${({ theme }) => theme.MQ.L} {
		${({ align }) => (align === 'center' ? 'text-align: center;' : 'padding-left: 80px;')}
	}
`
Hero.propTypes = {
	align: string,
	content: node,
	top: string,
}

/**
 * This Component is the Hero
 * This takes care of just the overlaying content within the hero banner
 * Background image is set within HeroBanner
 * (this is because of the opacity set, and originally we needed to flip the background image)
 */
export function Hero({ align, content, top }) {
	return (
		<HeroWrapper align={align} top={top}>
			{content}
		</HeroWrapper>
	)
}
